import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import css from './download-button.scss';

const DownloadButton = ({ onClick, title, icon, disabled }) => (
    <div
        className={css.button}
        onClick={onClick}
        tabIndex={0}
        role="button"
        disabled={disabled}
    >
        <Isvg className={css.icon} src={icon} cacheGetRequests />{' '}
        <span>{title}</span>
    </div>
);

DownloadButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    disabled: PropTypes.bool
};

export default styleable(css)(DownloadButton);



// WEBPACK FOOTER //
// ./components/certificates/components/certificate-confirmation-modal/components/download-button/download-button.js